// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const getPassiveRepeaterDataFromPathDetailsForm = () => (dispatch, getState) => {
    const {
        form,
        pathDetails,
      } = getState()
      const sourceForm = pathDetails.get('sourceForm')
      // passive values from form state.
      const { passiveRepeaters } = form[sourceForm].values
    
      // cleaned passive values - this is because redux-form can have an incomplete set
      // of fields in case they want to add more but they saved.
      // This skips the empty set so that the tooltip
      // only shows the full sets that are in redux-form.
      return (
        passiveRepeaters.reduce((a, d, i) => {
            if (d.site.siteName.length) {
            a.push(d)
            }
            return a
        }, [])
      )
}

export default getPassiveRepeaterDataFromPathDetailsForm
